/**
 * Resolves primary display name and optional secondary handle for the user's OWN dashboard.
 *
 * Rules (B700 / W9E):
 * - Primary display: "First Last" if both exist, then "First" if only first exists,
 *   falling back to username only if there is no name at all.
 * - Secondary line: @username where the design already has a handle line,
 *   and hidden if it would equal the primary text (preventing stacked identical strings).
 */
export function getOwnDashboardName(user) {
  if (!user) return { primary: '', secondary: null };

  const first = typeof user.firstName === 'string' ? user.firstName.trim() : '';
  const last = typeof user.lastName === 'string' ? user.lastName.trim() : '';
  const username = typeof user.username === 'string' ? user.username.trim() : '';

  let primary = '';
  if (first && last) {
    primary = `${first} ${last}`;
  } else if (first) {
    primary = first;
  } else if (last) {
    primary = last;
  } else if (username) {
    primary = username;
  }

  let secondary = null;
  if (username && primary.toLowerCase() !== username.toLowerCase()) {
    secondary = `@${username}`;
  }

  return { primary, secondary };
}
